import React from "react";
import { Card, Col, Row } from "antd";
import { ActionContact } from "./components/ActionContact";
import { ActionTodolist } from "./components/ActionTodolist";

import "./css/DashboardCollector.css";

interface Props {
  baseUrl: string;
}

export const DashboardManagerCollector: React.FC<Props> = ({ baseUrl }) => {
  return (
    <>
      <div
        className="scrolling-wrapper"
        style={{
          width: "100%",
          height: "70vh",
          marginTop: 0,
          textAlign: "left",
          display: "flex",
        }}
      >
        {/* <Row gutter={[5, 5]}> */}
        <div className="card" style={{ width: "400px" }}>
          <ActionTodolist baseUrl={baseUrl} />
        </div>
        <div className="card" style={{ width: "auto" }}>
          <ActionContact baseUrl={baseUrl} />
        </div>
        {/* </Row> */}
      </div>
    </>
  );
};
